export const discountType = {
  POP: '%',
  DAN: 'Dani',
  FIX: 'Fiksno',
};

export enum DiscountType {
  POP = 'POP',
  DAN = 'DAN',
  FIX = 'FIX',
}

export const discountTypeDropdown = [
  { value: 'POP', label: 'Postotak' },
  { value: 'DAN', label: 'Popust u danima' },
  { value: 'FIX', label: 'Fiksni iznos' },
];
